/* Sort names */
const nameSortDistance: 'distance' = 'distance';
const nameSortDistanceUser: 'distance-user' = 'distance-user';
const nameSortRelevance: 'relevance' ='relevance';
const nameSortRelevanceUser: 'relevance-user' ='relevance-user';
const nameSortName: 'name' = 'name';

/*
 * Export functions.
 */
export {
    nameSortDistance,
    nameSortDistanceUser,
    nameSortRelevance,
    nameSortRelevanceUser,
    nameSortName
}
